import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import PageTitle from "../../layouts/PageTitle";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import SubmitButton from "../../components/ui/SubmitButton";
import { getSingleAdminFunc } from "../../../store/custom-actions/admins-actions/GetSingleAdminSlicer";
import { updateAdminImageFunc } from "../../../store/custom-actions/admins-actions/UpdateAdminImageSlicer";

export default function UpdateAdminImage() {
  const { t } = useTranslation();
  const { adminId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleSubmit } = useForm();

  const { loading: getSingleAdminLoading, data: singleAdminData } = useSelector(
    (state) => state.getSingleAdminSlicer
  );
  const { loading: updateAdminImageLoading } = useSelector(
    (state) => state.updateAdminImageSlicer
  );

  const [adminImage, setAdminImage] = useState("");
  const [imageViwer, setImageViwer] = useState("");

  useEffect(() => {
    if (adminId) {
      dispatch(getSingleAdminFunc(adminId));
    }
  }, [adminId, dispatch]);

  useEffect(() => {
    if (singleAdminData) {
      setImageViwer(singleAdminData.image);
    }
  }, [singleAdminData]);

  const onSubmit = async () => {
    if (adminImage === "") {
      toast.error(t("Image must not be empty"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const adminFormData = new FormData();
    adminFormData.append("image", adminImage);
    adminFormData.append("_method", "PUT");

    const result = await dispatch(
      updateAdminImageFunc({ id: adminId, data: adminFormData })
    );

    if (updateAdminImageFunc.fulfilled.match(result)) {
      navigate("/admins");
    }
  };


  return (
    <>
      <PageTitle
        motherMenu={"Admins"}
        activeMenu={"Update Admin Image"}
        motherMenuPath="/admins"
      />
      {getSingleAdminLoading ? (
        <SpinnerLoading />
      ) : (
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">
                  {t("Update")} {t("Admin Image")}
                </h5>
              </div>
              <div className="card-body">
                <form
                  id="change-admin-image-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {adminImage !== "" && (
                    <div className="relative flex justify-center items-center mb-2">
                      <div className="relative w-[240px] h-[200px]">
                        <img
                          src={imageViwer}
                          alt="admin img"
                          className="absolute top-0 left-0 w-full h-full"
                        />
                      </div>
                    </div>
                  )}
                  <div className="w-full flex justify-center items-center mb-1">
                    <span className="text-sm">
                      {t("Best size")} (200px * 180px)
                    </span>
                  </div>
                  <div className="flex justify-center items-center">
                    <label htmlFor="file" className="file-upload-label">
                      <div className="file-upload-design">
                        <svg viewBox="0 0 640 512" height="1em">
                          <path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"></path>
                        </svg>
                        <span className="browse-button">{t("Browse file")}</span>
                      </div>
                      <input
                        id="file"
                        type="file"
                        accept="image/jpeg, image/png, image/jpg"
                        className="form-control"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const imageUrl = URL.createObjectURL(file);
                            setImageViwer(imageUrl);
                          }
                          setAdminImage(e.target.files[0]);
                        }}
                      />
                    </label>
                  </div>
                  <div className="text-end">
                    <SubmitButton
                      form="change-admin-image-form"
                      isLoading={updateAdminImageLoading}
                      disabled={adminImage === ""}
                      label="Submit"
                      loadingLabel={t("Loading")}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}